// LiveStreamSettingButton.jsx
import React, { useEffect } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import HamburgerIconSrc from '../../img/icon-hamburger-outline-shadow.svg';
import LDIconSrc from '../../img/ic_ld.svg';
import SDIconSrc from '../../img/ic_sd.svg';

import { color } from '../style/variables.js';
import ResetButtonStyle from '../style/ResetButtonStyle.js';
import { ButtonId } from '../resource/trackingConstants.js';
import { ModalStatus } from '../resource/modalConstants.js';
import defaults from '../resource/defaults.js';
import useClickWithTouchBackfill from '../hook/useClickWithTouchBackfill.js';

import media from '../style/media.js';

const modalViewRootId = 'stream-container';

export const LiveStreamSettingButton = ({
  lowDefinitionVideoIds = defaults.EMPTY_ARRAY,
  qualityFor = null,
  menuModalStatus = null,
  mountElementId = '',
  toggleSettingMenuModal = defaults.NULL_FUNCTION,
  isActive = null,
  updateShouldLogVideoResolution = defaults.NULL_FUNCTION,
}) => {
  const openLiveStreamSettingMenu = () => {
    toggleSettingMenuModal({
      modalId: 'LiveStreamSettingMenu',
      isOpen: true,
      payload: {
        mountElementId,
      },
    });
  };
  const handleMoreOnClick = () => {
    if (menuModalStatus === ModalStatus.CLOSING) return;
    openLiveStreamSettingMenu();
  };

  const moreClickProps = useClickWithTouchBackfill({
    onClick: handleMoreOnClick,
  });

  useEffect(() => {
    if (isActive) {
      updateShouldLogVideoResolution({ shouldLogVideoResolution: true });
    }
    return () => {
      if (isActive) {
        updateShouldLogVideoResolution({ shouldLogVideoResolution: false });
      }
    };
  }, [isActive, updateShouldLogVideoResolution]);

  const renderResolutionBadge = () => {
    if (!qualityFor) return null;

    const isLowDefinition = lowDefinitionVideoIds.includes(
      `${qualityFor['video']}` || ''
    );
    return (
      <ResolutionBadge>
        {isLowDefinition ? (
          <img src={LDIconSrc} alt="LD" width={12} height={6} />
        ) : (
          <img src={SDIconSrc} alt="SD" width={12} height={6} />
        )}
      </ResolutionBadge>
    );
  };

  return (
    <StyledLiveStreamSettingButton
      type="button"
      data-element_id={ButtonId.All.ButtonMore}
      data-sheet_mount_id={isActive ? mountElementId : ''}
      {...moreClickProps}
      id={isActive ? modalViewRootId : undefined}
    >
      <img src={HamburgerIconSrc} alt="Setting" />
      {renderResolutionBadge()}
    </StyledLiveStreamSettingButton>
  );
};

LiveStreamSettingButton.propTypes = {
  lowDefinitionVideoIds: PropTypes.array,
  menuModalStatus: PropTypes.string,
  mountElementId: PropTypes.string,
  isActive: PropTypes.bool,
  qualityFor: PropTypes.object,
  toggleSettingMenuModal: PropTypes.func,
  updateShouldLogVideoResolution: PropTypes.func,
};

const StyledLiveStreamSettingButton = styled.button`
  ${ResetButtonStyle};
  position: relative;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: ${color.neutral['0_alpha_20']};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${color.white};
  touch-action: manipulation;

  > img {
    object-fit: contain;
    pointer-events: none;

    width: 24px;
    height: 24px;

    ${media.tablet`
      width: 28px;
      height: 28px;
    `}
  }
  :last-child {
    margin-bottom: 0px;
  }
`;

const ResolutionBadge = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  padding: 2px;
  border-radius: 2px;
  background-color: ${color.grey[900]};
  display: inline-flex;
  padding: 2px;
  justify-content: center;
  align-items: center;
  pointer-events: none;
`;

export default LiveStreamSettingButton;
